console.log('property');



// const fadeInTarget = document.querySelectorAll('.point_img, .scaleUp, .lani, .slideIn');

// console.log(fadeInTarget);

// const observer = new IntersectionObserver((entries) => {
//     entries.forEach(entry => {
//         if (entry.isIntersecting) {
//             entry.target.classList.add('active');
//         } else {
//             entry.target.classList.remove('active');
//         }
//     });
// }, {
//     rootMargin: '-100px 0px',
//     threshold: 0
// });


// fadeInTarget.forEach(el => observer.observe(el));


// document.addEventListener("DOMContentLoaded", (event) => {
//     gsap.registerPlugin(ScrollTrigger)
//     // gsap code here!

//     const pointImg = document.querySelectorAll('.point_img');
//     if (window.matchMedia('(min-width: 769px)').matches) {
//         pointImg.forEach((img) => {
//             gsap.set(img, {
//                 yPercent: -50,
//                 y: 30,
//             })
//             gsap.to(img, {
//                 y: -30,
//                 scrollTrigger: {
//                     trigger: img,
//                     start: 'top bottom',
//                     end: 'bottom top',
//                     scrub: 1
//                 }
//             })
//         })
//     }
// });